module.exports = __webpack_public_path__ + "img/PlantTFDB.acdb08fc.png";